import api from './client.js'

export const clanAPI = {
  getStatus:  ()        => api.get('/clan/status'),
  getMembers: ()        => api.get('/clan/members'),
  getUsers:   ()        => api.get('/clan/users'),
  sync:       ()        => api.post('/clan/sync'),
  autoLink:   ()        => api.post('/clan/auto-link'),
  linkUser:   (id, uid, source) => api.put(`/clan/users/${id}/link`, { clan_uid: uid, source }),
  getKassaCards: ()      => api.get('/clan/kassa-cards'),
  unlinkUser: (id)      => api.delete(`/clan/users/${id}/link`),
}
